import type { FaireProductEntity } from "../../entity_types/product";

export const p_tsv44jnde3: FaireProductEntity = {
  token: "p_tsv44jnde3",
  type: "product",
  name: "The Easter Egg Hunt in Arkansas",
  brandToken: "b_14eeavl3ro",
  brandName: "Sourcebooks",
  imageUrl:
    "https://cdn.faire.com/fastly/6ab0895c898a5c6dbf2b04bc86dcaf4441b2829223549dd5e4489cbd503d8b12.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/272f007ddafec33087460e9e50153a6d506fdb30872843514055ef1848f1c186.jpeg",
  ],
  priceDollars: 7.61,
  description:
    "Search for Easter eggs with Little Bunny and hippity-hop around your hometown with this springtime read-aloud children's picture book!\n\nIt's Easter, which means Little Bunny is searching for eggs! Eggs are hidden all around your hometown—can you help Little Bunny find them? Follow along on a tour around town through the market and past the farm. Join in as Little Bunny makes sweet memories with adorable animal friends along the way. This Easter basket stuffer is the best way to celebrate the holiday, full of sweet illustrations and rhyming text ideal for parents and kids to read-aloud.",
  tags: [],
  msrpDollars: 15.23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:12.559Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
